/* Eiken — Paysage de bas de page : repli d'animation au scroll (2026-08-28)
   Repli SEULEMENT pour les navigateurs sans scroll-driven animations CSS
   (Firefox stable, Safari < 26). Ailleurs, sortie immédiate, coût nul.
   Écrit une seule chose : --eiken-p (0 → 1) sur .eiken-paysage ; tout le
   rendu reste dans eiken-paysage.css.
   Un seul rAF coalescé sur scroll, géométrie en cache, lecture avant
   écriture, IO déconnecté et will-change retiré hors viewport. */
(function () {
  'use strict';

  var scene = document.querySelector('.eiken-paysage[data-animate="true"]');
  // Pas cette page, ou animation coupée dans l'éditeur : on ne fait rien.
  // La feuille de style porte le même garde `[data-animate="true"]`, les deux
  // chemins s'éteignent donc ensemble, jamais l'un sans l'autre.
  if (!scene) return;

  // Le navigateur sait le faire nativement, en dehors du thread principal.
  // On n'installe strictement rien. (Même test que le @supports du CSS.)
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  // Plage identique à `animation-range: cover 8% cover 58%` du CSS.
  var DEBUT = 0.08;
  var FIN = 0.58;
  var ETENDUE = FIN - DEBUT;

  // Géométrie en cache. Jamais relue dans la boucle.
  var hautDoc = 0;   // distance haut-du-document → haut de la scène
  var hauteur = 0;   // hauteur de la scène en px
  var fenetre = 0;   // innerHeight

  var actif = false;
  var trame = 0;     // id du rAF en attente (0 = aucun)
  var precedent = -1;
  var minuteur = 0;  // anti-rebond du resize

  function mesurer() {
    var r = scene.getBoundingClientRect();
    fenetre = window.innerHeight || document.documentElement.clientHeight || 0;
    hautDoc = r.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
    hauteur = r.height;
  }

  function peindre() {
    trame = 0;

    // LECTURE d'abord, ÉCRITURE ensuite : pas de reflow synchrone.
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;

    // Progression « cover » : 0 quand le haut de la scène touche le bas de la
    // fenêtre, 1 quand le bas de la scène franchit le haut de la fenêtre.
    var course = fenetre + hauteur;
    var brut = course > 0 ? (y + fenetre - hautDoc) / course : 0;

    var p = (brut - DEBUT) / ETENDUE;
    if (p < 0) p = 0; else if (p > 1) p = 1;

    // Quantifié à 1/500 : sous ce seuil le déplacement est sous-pixel, on
    // s'épargne une invalidation de style pour rien.
    p = Math.round(p * 500) / 500;

    if (p !== precedent) {
      precedent = p;
      scene.style.setProperty('--eiken-p', p);
    }
  }

  function programmer() {
    if (!trame) trame = requestAnimationFrame(peindre);
  }

  function auResize() {
    if (minuteur) clearTimeout(minuteur);
    minuteur = setTimeout(function () {
      minuteur = 0;
      mesurer();
      programmer();
    }, 150);
  }

  function demarrer() {
    if (actif || (mq && mq.matches)) return;
    actif = true;
    scene.classList.add('is-animating');   // pose will-change (cf. eiken-paysage.css)
    mesurer();
    window.addEventListener('scroll', programmer, { passive: true });
    window.addEventListener('resize', auResize);
    programmer();
  }

  function arreter() {
    if (!actif) return;
    actif = false;
    window.removeEventListener('scroll', programmer);
    window.removeEventListener('resize', auResize);
    if (trame) { cancelAnimationFrame(trame); trame = 0; }
    if (minuteur) { clearTimeout(minuteur); minuteur = 0; }
    scene.classList.remove('is-animating'); // retire will-change
  }

  var io = null;

  function brancher() {
    if (mq && mq.matches) {                 // mouvement réduit : rien du tout
      debrancher();
      scene.style.removeProperty('--eiken-p');
      precedent = -1;
      return;
    }
    if (io || !('IntersectionObserver' in window)) {
      if (!io) demarrer();                  // pas d'IO : on tourne en continu
      return;
    }
    // 300 px de marge : la boucle est déjà chaude quand la scène apparaît.
    io = new IntersectionObserver(function (entrees) {
      if (entrees[entrees.length - 1].isIntersecting) demarrer();
      else arreter();
    }, { rootMargin: '300px 0px 300px 0px' });
    io.observe(scene);
  }

  function debrancher() {
    arreter();
    if (io) { io.disconnect(); io = null; }
  }

  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', brancher);
    else if (mq.addListener) mq.addListener(brancher);
  }

  brancher();
})();
